import { connect } from 'react-redux';

import { fetchNotifications } from 'api/clients/clients.actions';
import { createModalOpenAction } from 'actions/modalActions';
import { NotificationsTable } from './notificationsTable';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchNotifications: () => dispatch(fetchNotifications()),
  openEmailTemplatePreviewModal: (clientId: string) =>
    dispatch(createModalOpenAction('email-template-modal' as any, { clientId })),
  openSurveyTemplatePreviewModal: (clientId: string) =>
    dispatch(createModalOpenAction('survey-template-modal' as any, { clientId })),
  openClipPreviewModal: (clientId: string, active: boolean) =>
    dispatch(createModalOpenAction('clip-preview-requested-modal' as any, { clientId, active })),
});

export const NotificationsTableContainer = connect(null, mapDispatchToProps)(NotificationsTable);
